import { Reducer } from 'redux';
import { HorariosDisponiveisState, HorariosDisponiveisTypes } from './types';

const INITIAL_STATE: HorariosDisponiveisState = {
  data: undefined,
  error: false,
  loading: false,
};

const reducer: Reducer<HorariosDisponiveisState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case HorariosDisponiveisTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case HorariosDisponiveisTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case HorariosDisponiveisTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: undefined,
      };

    case HorariosDisponiveisTypes.CLEAN_HORARIOSDISPONIVEIS:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
